module.exports = __webpack_public_path__ + "img/train-or-fight.b94dafa2.svg";